import { generateBaseQueryKeysList } from '@/queries/utils';

export const TRIALS_KEYS = {
  list: 'trials',
};

export const trialsQueryKeys = generateBaseQueryKeysList(TRIALS_KEYS.list);
